import {
  UseMutateFunction,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import {
  DeleteFormSectionConfigDto,
  FormSectionDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_FORM_SECTIONS_CONFIG } from "../domain";

import { formsSectionsConfigApi } from "@api/services";
import { ACTION_GET_FORM_SECTIONS, DOMAIN_FORMS, roleGuard } from "@api";

const ACTION_UPDATE_FORM_SECTION_CONFIG = "UPDATE_FORM_SECTION_CONFIG";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

const deleteFormSectionConfig = async (
  sectionId: string,
): Promise<DeleteFormSectionConfigDto> => {
  const response =
    await formsSectionsConfigApi.formSectionsConfigControllerDeleteFormSectionConfig(
      sectionId,
    );

  return response.data;
};

export const useDeleteFormSectionConfig = (
  user: UserProfileDto | null,
  formId: string,
): {
  deleteFormSectionConfig: UseMutateFunction<
    DeleteFormSectionConfigDto,
    Error,
    string,
    unknown
  >;
  deleteFormSectionConfigEnabled: boolean;
  isSuccessDeleteFormSectionConfig: boolean;
  isPendingDeleteFormSectionConfig: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();
  const { mutate, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_FORM_SECTIONS_CONFIG, ACTION_UPDATE_FORM_SECTION_CONFIG],
    mutationFn: enabled ? deleteFormSectionConfig : undefined,
    onSuccess(data: { sectionId: string }) {
      const queryKey = [DOMAIN_FORMS, ACTION_GET_FORM_SECTIONS, formId];
      const currentData = queryClient.getQueryData<FormSectionDto[] | undefined>(
        queryKey,
      );

      queryClient.setQueryData(queryKey, () => {
        return currentData?.filter((d) => d.id !== data.sectionId);
      });
    },
  });

  return {
    deleteFormSectionConfig: mutate,
    deleteFormSectionConfigEnabled: enabled,
    isSuccessDeleteFormSectionConfig: isSuccess,
    isPendingDeleteFormSectionConfig: isPending,
  };
};
